import UnstyledTextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

export const TextField = styled(UnstyledTextField)(({ theme }) => ({
  borderRadius: 8,
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: theme.palette.divider,
      borderRadius: 12,
    },
    backgroundColor: theme.palette.background.paper,
  },
}));
